// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3chuV","list":"BalanceDue_list__3luqn","listRow":"BalanceDue_listRow__2J5uF","total":"BalanceDue_total__rBY_X"};